import BomDiff from "./BomDiff";
import { Board, BoardRevisions } from "../../../reducers/uploadedBoard";
import { SelectParent } from "../ManufacturersPanelStyles";
import { SelectContainer, SelectOption } from "../../common/FancySelect";
import { FONT_SIZE } from "../../../constants/Styles";
import React, { useCallback, useEffect } from "react";
import { useRouter } from "next/router";
import MessagesAndNotes from "./MessagesAndNotes";
import PhysicalDetails from "./PhysicalDetails";

export enum DiffTab {
  BILL_OF_MATERIALS = "Bill of materials",
  MESSAGES_AND_NOTES = "Messages and notes",
  PHYSICAL_DETAILS = "Physical details",
}

export default function RevisionsOptions({
  revisions,
  previousRevision,
}: {
  revisions: BoardRevisions;
  previousRevision: Board | null;
}) {
  const router = useRouter();
  const diffView = router.query.diffView as DiffTab | undefined;

  const setDiffView = useCallback(
    (diffTab: DiffTab) => {
      const newPath = {
        pathname: router.pathname,
        query: {
          ...router.query,
          diffView: diffTab,
        },
      };
      // update the URL, without re-triggering data fetching
      void router.replace(newPath, undefined, { scroll: false });
    },
    [router],
  );

  useEffect(() => {
    if (diffView === undefined || !Object.values(DiffTab).includes(diffView)) {
      setDiffView(DiffTab.BILL_OF_MATERIALS);
    }
  }, [diffView, setDiffView]);

  return (
    <>
      <SelectParent>
        <SelectContainer>
          {Object.values(DiffTab).map((tab) => {
            return (
              <SelectOption
                key={tab}
                isSelected={tab === diffView}
                onClick={() => setDiffView(tab)}
                fontSize={FONT_SIZE.size16}
              >
                {tab}
              </SelectOption>
            );
          })}
        </SelectContainer>
      </SelectParent>
      {diffView == DiffTab.BILL_OF_MATERIALS && (
        <BomDiff diff={revisions.diff} />
      )}
      {diffView == DiffTab.MESSAGES_AND_NOTES && (
        <MessagesAndNotes previousRevision={previousRevision} />
      )}
      {diffView == DiffTab.PHYSICAL_DETAILS && (
        <PhysicalDetails diff={revisions.diff} />
      )}
    </>
  );
}
